"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.backendTypesMap = exports.backendChallengeTypes = exports.GeogroupService = void 0;
exports.parseChallenge = parseChallenge;
exports.parseChallengeTemplate = parseChallengeTemplate;
exports.parseGeogroup = parseGeogroup;
exports.typesMap = exports.subGroupTypesMap = void 0;
var _moment = _interopRequireDefault(require("moment"));
var _environment = require("../environment");
var _models = require("../models");
var _stats = require("../utils/stats");
var _app = require("./app");
var _http = require("./http");
var _jersey = require("./jersey");
var _partner = require("./partner");
var _publicationStatus = require("./publication-status");
var _stats2 = require("./stats");
var _user = require("./user");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const typesMap = exports.typesMap = {
  company: 'COMPANY',
  school: 'SCHOOL',
  association: 'ASSOCIATION',
  city: 'CITY',
  private: 'PRIVATE',
  other: 'ASSOCIATION'
};
const backendTypesMap = exports.backendTypesMap = {
  ASSOCIATION: 'association',
  CITY: 'city',
  COMPANY: 'company',
  PRIVATE: 'private',
  OTHER: 'other',
  SCHOOL: 'school'
};
class GeogroupService {
  static async getGeogroups({
    ordering,
    page,
    pageSize,
    parentId,
    query,
    search,
    types,
    onlyLinkedToPartner
  } = {}) {
    try {
      const params = [{
        key: 'page_size',
        value: pageSize || 100
      }];
      if (ordering) params.push({
        key: 'ordering',
        value: ordering
      });
      if (page) params.push({
        key: 'page',
        value: page
      });
      if (parentId) params.push({
        key: 'parent_id',
        value: parentId
      });
      if (query) params.push({
        key: 'query',
        value: query
      });
      if (search) params.push({
        key: 'search',
        value: search
      });
      if (types) params.push({
        key: 'group_type[]',
        value: types.map(key => _models.geogroupTypes.includes(key) ? typesMap[key] : backendSubGroupTypesMap[key]).join(',')
      });
      if (onlyLinkedToPartner !== undefined) params.push({
        key: 'linked_to_partner',
        value: !onlyLinkedToPartner
      });
      const {
        count,
        next,
        results
      } = await _http.HttpService.get('v4', `/geogroups`, params);
      const geogroups = results.map(data => parseGeogroup(data, _app.AppService.environment.backendUrl));
      return {
        count,
        hasNext: Boolean(next),
        geogroups
      };
    } catch (err) {
      console.error('[GeogroupService][getGeogroups]', err);
      throw err;
    }
  }
  static async getGeogroup({
    geoGroupId
  }) {
    if (geoGroupId === null) throw new Error('partner has no geogroup identifier');
    try {
      const data = await _http.HttpService.get('v4', `/geogroups/${geoGroupId}`);
      return parseGeogroup(data, _app.AppService.environment.backendUrl);
    } catch (err) {
      console.error('[GeogroupService][getGeogroup]', err);
      throw typeof err === 'object' && err && 'detail' in err && typeof err.detail === 'string' ? new Error(err.detail) : err;
    }
  }
  static async getInvitationLink(id) {
    try {
      const data = await _http.HttpService.post('v2', `/geogroups/${id}/invitations`);
      const {
        code
      } = data;
      return {
        link: `${_app.AppService.environment.frontendUrl}/communities/invites/${code}`,
        code
      };
    } catch (err) {
      console.error('[GeogroupService][getInvitationLink]', err);
      throw err;
    }
  }
  static async getGeogroupFromInvitationCode(code) {
    try {
      const data = await _http.HttpService.get('v2', `/geogroups/invitations/${code}`);
      return parseGeogroup(data, _app.AppService.environment.backendUrl);
    } catch (err) {
      console.error('[GeogroupService][getGeogroupFromInvitationCode]', err);
      throw err;
    }
  }
  static async getUserGeogroups({
    parentId,
    statuses
  } = {}) {
    try {
      if (!_user.UserService.currentUser) throw new Error('user not connected');
      const params = [];
      if (parentId) params.push({
        key: 'parent_id',
        value: parentId
      });
      if (statuses) {
        params.push({
          key: 'geogroup_join_type',
          value: statuses.join(',')
        });
      }
      const res = await _http.HttpService.get('v6', `/users/${_user.UserService.currentUser.id}/geogroups`, params);
      const geogroups = res.map(data => parseUserGeogroup(data, _app.AppService.environment.backendUrl));
      return geogroups;
    } catch (err) {
      console.error('[GeogroupService][getUserGeogroups]', err);
      throw err;
    }
  }
  static async getUserGeogroup(id) {
    try {
      if (!_user.UserService.currentUser) throw new Error('user not connected');
      const res = await _http.HttpService.get('v2', `/users/${_user.UserService.currentUser.id}/geogroups/${id}`);
      return parseUserGeogroup(res, _app.AppService.environment.backendUrl);
    } catch (err) {
      console.error('[GeogroupService][getUserGeogroup]', err);
      throw err;
    }
  }
  static async updateUserGeogroup(id, {
    userType: user_type
  }) {
    try {
      if (!_user.UserService.currentUser) throw new Error('user not connected');
      const res = await _http.HttpService.patch('v2', `/users/${_user.UserService.currentUser.id}/geogroups/${id}`, [], [], JSON.stringify({
        user_type
      }));
      return parseUserGeogroup(res, _app.AppService.environment.backendUrl);
    } catch (err) {
      console.error('[GeogroupService][updateUserGeogroup]', err);
      throw err;
    }
  }
  static async addGeogroups({
    partner,
    groups
  }) {
    try {
      const body = groups.map(({
        type,
        name,
        address,
        parentId,
        subGroupType,
        siret
      }) => {
        let data = {
          type: typesMap[type],
          title: name,
          code: name.trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\s+/g, '_'),
          size_range: JSON.stringify({
            min: 0,
            max: 100_000_000
          }),
          automatic_challenge_creation: 'DISABLED'
        };
        if (address) data = {
          ...data,
          geo_point: JSON.stringify(address.point),
          address: address.address
        };
        if (parentId) data.parent = `${parentId}`;
        if (subGroupType) data.sub_group_type = backendSubGroupTypesMap[subGroupType];
        if (siret) data.siret_number = siret;
        return data;
      });
      const res = await _http.HttpService.post('v4', `/geogroups`, [], [], JSON.stringify(body), partner ? {
        partner: partner.code
      } : {});
      return res.map(props => parseGeogroup(props, _app.AppService.environment.backendUrl));
    } catch (err) {
      console.error('[GeogroupService][addGeogroups]', err);
      throw err;
    }
  }
  static async addGeogroup({
    type,
    name,
    areaId,
    min,
    max,
    address,
    icon,
    automaticChallengeStatus,
    bannerPicture,
    publicationStatus,
    partner,
    parentId,
    subGroupType,
    description,
    linkUrl,
    linkLabel,
    siret,
    disableAutoJoin
  }) {
    try {
      let data = {
        type: typesMap[type],
        title: name,
        code: name.trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\s+/g, '_'),
        size_range: JSON.stringify({
          min: min || 0,
          max: max || 100_000_000
        }),
        automatic_challenge_creation: automaticChallengeStatus ? backendAutomaticChallengeStatusMap[automaticChallengeStatus] : 'disabled'
      };
      if (areaId) data.area = `${areaId}`;
      if (address) data = {
        ...data,
        geo_point: JSON.stringify(address.point),
        address: address.address
      };
      if (publicationStatus === 'published') data.publication_status = 'PUBLISHED';
      if (parentId) data.parent = `${parentId}`;
      if (subGroupType) data.sub_group_type = backendSubGroupTypesMap[subGroupType];
      if (description !== undefined) data = {
        ...data,
        description
      };
      if (linkUrl !== undefined) {
        data = {
          ...data,
          link_url: linkUrl,
          link_label: linkLabel || ''
        };
      }
      if (siret !== undefined) data = {
        ...data,
        siret
      };
      const formData = new FormData();
      Object.keys(data).forEach(key => formData.append(key, data[key]));
      if (icon) formData.append('photo', icon);
      if (bannerPicture) formData.append('banner_picture', bannerPicture);
      const queryParams = [];
      if (disableAutoJoin) queryParams.push({
        key: 'no_auto_join',
        value: true
      });
      const props = await _http.HttpService.post('v4', `/geogroups`, queryParams, [], formData, partner ? {
        partner: partner.code
      } : {});
      return parseGeogroup(props, _app.AppService.environment.backendUrl);
    } catch (err) {
      console.error('[GeogroupService][addGeogroup]', err);
      throw err;
    }
  }
  static async updateGeogroup(id, {
    type,
    name,
    min,
    max,
    address,
    icon,
    automaticChallengeStatus,
    bannerPicture,
    description,
    linkUrl,
    linkLabel,
    publicationStatus
  }, partner) {
    try {
      let data = {};
      if (type) data.type = typesMap[type];
      if (name) data = {
        ...data,
        title: name,
        code: name.trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\s+/g, '_')
      };
      if (min !== undefined || max !== undefined) {
        data.size_range = JSON.stringify({
          min: min || 0,
          max: max || 100_000_000
        });
      }
      if (automaticChallengeStatus !== undefined) data.automatic_challenge_creation = backendAutomaticChallengeStatusMap[automaticChallengeStatus];
      if (address) data = {
        ...data,
        geo_point: JSON.stringify(address.point),
        address: address.address
      };
      if (description !== undefined) data = {
        ...data,
        description
      };
      if (linkUrl !== undefined) {
        data = {
          ...data,
          link_url: linkUrl,
          link_label: linkLabel || ''
        };
      }
      if (publicationStatus) data.publication_status = _publicationStatus.backendPublicationStatuses[publicationStatus];
      const formData = new FormData();
      Object.keys(data).forEach(key => formData.append(key, data[key]));
      if (icon !== undefined) formData.append('photo', icon || '');
      if (bannerPicture !== undefined) formData.append('banner_picture', bannerPicture || '');
      const props = await _http.HttpService.patch('v4', `/geogroups/${id}`, [], [], formData, partner ? {
        partner: partner.code
      } : undefined);
      return parseGeogroup(props, _app.AppService.environment.backendUrl);
    } catch (err) {
      console.error('[GeogroupService][updateGeogroup]', err);
      throw err;
    }
  }
  static async removeGeogroup(id, partner) {
    try {
      if (!_user.UserService.currentUser) throw new Error('user not connected');
      await _http.HttpService.delete('v4', `/geogroups/${id}`, [], [], null, partner?.code ? {
        partner: partner.code
      } : undefined);
    } catch (err) {
      console.error('[GeogroupService][removeGeogroup]', err);
      throw err;
    }
  }
  static async joinGeogroup(id, {
    disabledRetrieval,
    userId,
    partnerCode,
    firstName,
    lastName
  } = {}) {
    try {
      if (!userId && !_user.UserService.currentUser) throw new Error('user not connected');
      const data = await _http.HttpService.post('v6', `/users/${userId || _user.UserService.currentUser?.id}/geogroups`, [], [], JSON.stringify({
        group: id,
        ...(firstName ? {
          first_name: firstName
        } : {}),
        ...(lastName ? {
          last_name: lastName
        } : {})
      }), partnerCode ? {
        partner: partnerCode
      } : undefined);
      if (!disabledRetrieval && typeof data.group === 'number') {
        data.group = await _http.HttpService.get('v4', `/geogroups/${id}`);
      }
      return parseUserGeogroup(data, _app.AppService.environment.backendUrl);
    } catch (err) {
      console.error('[GeogroupService][joinGeogroup]', err);
      throw err;
    }
  }
  static async joinGeogroupWithInvitation(code, {
    geogroupId
  } = {}) {
    try {
      if (!_user.UserService.currentUser) throw new Error('user not connected');
      const data = await _http.HttpService.post('v2', `/users/${_user.UserService.currentUser.id}/geogroups/invitations/${code}`, geogroupId ? [{
        key: 'group',
        value: geogroupId
      }] : []);
      return parseUserGeogroup(data, _app.AppService.environment.backendUrl);
    } catch (err) {
      console.error('[GeogroupService][joinGeogroupWithInvitation]', err);
      return null;
    }
  }
  static async leaveGeogroup(id, {
    userId,
    partnerCode
  } = {}) {
    try {
      if (!userId && !_user.UserService.currentUser) throw new Error('user not connected');
      await _http.HttpService.delete('v2', `/users/${userId || _user.UserService.currentUser?.id}/geogroups/${id}`, [], [], null, partnerCode ? {
        partner: partnerCode
      } : undefined);
    } catch (err) {
      console.error('[GeogroupService][leaveGeogroup]', err);
      throw err;
    }
  }
  static async getMembers(geoGroupId, {
    partner,
    page,
    pageSize,
    orderBy,
    order,
    registrationStartDate,
    registrationEndDate,
    onlyNew,
    joinTypes,
    userType
  }) {
    try {
      const params = [];
      if (orderBy && order) {
        let value;
        if (orderBy === 'username') value = 'user__username';else if (orderBy === 'joinDate') value = 'join_date';else if (orderBy === 'distance') value = 'meters';
        if (value) {
          if (order === 'desc') value = `-${value}`;
          params.push({
            key: 'ordering',
            value
          });
        }
      }
      if (registrationStartDate || registrationEndDate) {
        if (registrationStartDate) params.push({
          key: 'date_start',
          value: registrationStartDate.format('YYYY-MM-DD')
        });
        if (registrationEndDate) params.push({
          key: 'date_end',
          value: registrationEndDate.format('YYYY-MM-DD')
        });
      } else if (onlyNew) params.push({
        key: 'only_new',
        value: true
      });
      if (joinTypes) {
        params.push(...joinTypes.map(key => ({
          key: 'join_type[]',
          value: backendUserGeogroupStatuses[key]
        })));
      }
      if (userType) {
        params.push({
          key: 'user_type',
          value: userType
        });
      }
      const data = await _http.HttpService.get('v3', `/geogroups/${geoGroupId}/users`, [{
        key: 'page',
        value: page
      }, {
        key: 'page_size',
        value: pageSize
      }, ...params], [], null, {
        partner: partner?.code
      });
      const users = data.results.reduce((res, userData) => {
        const user = parseGeogroupMember(userData);
        if (user) res.push(user);
        return res;
      }, []);
      return {
        count: data.count,
        users,
        hasNext: Boolean(data.next)
      };
    } catch (err) {
      console.error('[GeogroupService][getMembers]', err);
      throw err;
    }
  }
  static async getMembersCount(geoGroupId, {
    partner,
    registrationStartDate,
    registrationEndDate,
    joinTypes
  }) {
    try {
      const params = [];
      if (registrationStartDate || registrationEndDate) {
        if (registrationStartDate) params.push({
          key: 'date_start',
          value: registrationStartDate.format('YYYY-MM-DD')
        });
        if (registrationEndDate) params.push({
          key: 'date_end',
          value: registrationEndDate.format('YYYY-MM-DD')
        });
      }
      if (joinTypes) {
        params.push(...joinTypes.map(key => ({
          key: 'join_type[]',
          value: backendUserGeogroupStatuses[key]
        })));
      }
      const {
        count
      } = await _http.HttpService.get('v2', `/geogroups/${geoGroupId}/users_count`, params, [], null, {
        partner: partner?.code
      });
      return {
        count
      };
    } catch (err) {
      console.error('[GeogroupService][getMembersCount]', err);
      throw err;
    }
  }
  static async removeMember({
    geoGroupId
  }, {
    id
  }) {
    try {
      await _http.HttpService.delete('v2', `/geogroups/${geoGroupId}/users/${id}`);
      return true;
    } catch (err) {
      console.error('[GeogroupService][removeMember]', err);
      throw err;
    }
  }
  static async getChallenges(geoGroupId, {
    period,
    page,
    pageSize,
    query,
    state,
    order,
    retrieveSubgroupsChallenges,
    sites
  }) {
    try {
      const params = [{
        key: 'page',
        value: page
      }, {
        key: 'page_size',
        value: pageSize
      }, {
        key: 'target_type[]',
        value: 'TRAVELED_DISTANCE'
      }, {
        key: 'target_type[]',
        value: 'CYCLING_DAYS'
      }, {
        key: 'target_type[]',
        value: 'TRACES_COUNT'
      }, {
        key: 'target_type[]',
        value: 'NO_TARGET'
      }, {
        key: 'target_type[]',
        value: 'BTTF_POINTS'
      }];
      if (query) params.push({
        key: 'query',
        value: query
      });
      if (period?.type === 'custom') params.push(...(0, _models.periodToParams)(period.toIPeriod()));
      if (state) state.forEach(value => params.push({
        key: 'state[]',
        value
      }));
      if (order) params.push({
        key: 'ordering',
        value: order
      });
      if (retrieveSubgroupsChallenges) params.push({
        key: 'add_sub_group_challenge',
        value: true
      });
      const {
        count,
        next,
        results
      } = await _http.HttpService.get('v5', `/geogroups/${geoGroupId}/challenges`, params);
      const challenges = results.reduce((res, data) => {
        const challenge = parseChallenge(data, _app.AppService.environment.backendUrl, sites);
        if (challenge) res.push(challenge);
        return res;
      }, []);
      return {
        challenges,
        count,
        hasNext: Boolean(next)
      };
    } catch (err) {
      console.error('[GeogroupService][getChallenges]', err);
      throw err;
    }
  }
  static async getChallenge(geoGroupId, challengeId, sites) {
    try {
      const data = await _http.HttpService.get('v4', `/geogroups/${geoGroupId}/challenges/${challengeId}`);
      const challenge = parseChallenge(data, _app.AppService.environment.backendUrl, sites);
      if (!challenge) throw new Error('challenge not published or challenge type not taken into account');
      return challenge;
    } catch (err) {
      console.error('[GeogroupService][getChallenge]', err);
      throw err;
    }
  }
  static async addChallenge({
    code,
    geoGroupId
  }, props, photo, {
    expectedStatus
  } = {}) {
    try {
      if (!geoGroupId) throw new Error('invalid geogroupId');
      if (!props.event && !props.collaboration_type) props.collaboration_type = 'EVERYONE';
      let body;
      if (photo) {
        body = new FormData();
        body.append('photo', photo);
        body.append('data', JSON.stringify(props));
      } else {
        body = JSON.stringify(props);
      }
      const result = await _http.HttpService.post('v5', `/geogroups/${geoGroupId}/challenges`, [], [], body, code ? {
        partner: code,
        expectedStatus
      } : undefined);
      const challenge = parseChallenge(result, _app.AppService.environment.backendUrl);
      if (!challenge) throw new Error('challenge not published or challenge type not taken into account');
      return challenge;
    } catch (err) {
      console.error('[GeogroupService][addChallenge]', err);
      throw err;
    }
  }
  static async updateChallenge({
    code,
    geoGroupId
  }, props, photo) {
    try {
      if (!geoGroupId) throw new Error('partner has no geogroup');
      let body;
      if (photo || photo === null) {
        body = new FormData();
        body.append('photo', photo || '');
        body.append('data', JSON.stringify(props));
      } else {
        body = JSON.stringify(props);
      }
      const data = await _http.HttpService.put('v4', `/geogroups/${geoGroupId}/challenges/${props.id}`, [], [], body, {
        partner: code
      });
      const challenge = parseChallenge(data, _app.AppService.environment.backendUrl);
      if (!challenge) throw new Error('challenge not published or challenge type not taken into account');
      return challenge;
    } catch (err) {
      console.error('[GeogroupService][updateChallenge]', err);
      throw err;
    }
  }
  static async removeChallenge({
    code,
    geoGroupId
  }, id) {
    try {
      await _http.HttpService.delete('v4', `/geogroups/${geoGroupId}/challenges/${id}`, [], [], null, {
        partner: code
      });
      return true;
    } catch (err) {
      console.error('[GeogroupService][removeChallenge]', err);
      throw err;
    }
  }
  static async getChallengeLeaderboard(challengeId, {
    page,
    pageSize,
    subgroup,
    userId
  }) {
    try {
      const params = [{
        key: 'page',
        value: page
      }, {
        key: 'page_size',
        value: pageSize
      }];
      if (subgroup) params.push({
        key: 'subgroup_id',
        value: subgroup.id
      });
      if (userId) params.push({
        key: 'user_id',
        value: userId
      });
      const {
        results,
        next,
        count
      } = await _http.HttpService.get('v4', `/challenges/${challengeId}/leaderboard`, params);
      const leaderboard = results.map(({
        user_id: id,
        username,
        firstname: firstName,
        lastname: lastName,
        professional_email: professionalEmail,
        rank,
        leaderboard_index: leaderboardIndex,
        progress_value: progressValue,
        jerseys,
        subgroups,
        profile_picture
      }) => ({
        id,
        username: username || null,
        firstName,
        lastName,
        professionalEmail,
        rank,
        leaderboardIndex,
        progressValue,
        jerseys: jerseys?.map(type => _jersey.backendJerseyTypesMap[type]) || [],
        subGroups: subgroups?.map(({
          id,
          sub_group_type,
          title
        }) => ({
          id,
          type: subGroupTypesMap[sub_group_type],
          title
        })) || [],
        profilePicture: profile_picture ? `${_environment.defaultEnvironment.backendUrl}${profile_picture}` : profile_picture
      }));
      return {
        count,
        leaderboard,
        hasMore: Boolean(next)
      };
    } catch (err) {
      console.error('[GeogroupService][getChallengeLeaderboard]', err);
      throw err;
    }
  }
  static async getChallengeLeaderboardBySubGroups({
    code: partner
  }, challengeId, {
    subGroupDisplay
  }) {
    try {
      const results = await _http.HttpService.get('v2', `/challenges/${challengeId}/subgroup_leaderboard`, [{
        key: 'sub_group_type',
        value: subGroupDisplay && backendSubGroupTypesMap[subGroupDisplay] || 'COMPANY_DEPARTMENT'
      }], [], null, {
        partner
      });
      const leaderboard = results.map(({
        id,
        title,
        rank,
        progress_value: progressValue,
        user_count_with_not_null_progress: participants
      }) => ({
        id,
        username: title || '',
        rank,
        progressValue,
        participants
      }));
      return leaderboard;
    } catch (err) {
      console.error('[GeogroupService][getChallengeLeaderboardBySubGroups]', err);
      throw err;
    }
  }
  static async getLeaderboardBySubGroups({
    code: partner,
    geoGroupId
  }, {
    jersey,
    subGroupDisplay,
    page,
    pageSize
  }) {
    try {
      const {
        count,
        results
      } = await _http.HttpService.get('v3', `/geogroups/${geoGroupId}/subgroup_windowed_activity_leaderboard`, [{
        key: 'leaderboard_type',
        value: jersey === 'distance' ? 'distance' : 'count_commuting_trace'
      }, {
        key: 'sub_group_type',
        value: subGroupDisplay && backendSubGroupTypesMap[subGroupDisplay] || 'COMPANY_DEPARTMENT'
      }, {
        key: 'page',
        value: page
      }, {
        key: 'page_size',
        value: pageSize
      }], [], null, {
        partner
      });
      const items = results.map(({
        id,
        rank,
        leaderboard_index: leaderboardIndex,
        title,
        progress_value: progressValue,
        counter_active_user: nbMembers,
        counter_active_user_with_home_work_trace: nbMembersWithHomeWorkTrace
      }) => ({
        type: 'distance',
        id,
        rank,
        leaderboardIndex,
        progressValue,
        group: {
          id,
          title,
          nbMembers,
          nbMembersWithHomeWorkTrace
        }
      }));
      return {
        count,
        items
      };
    } catch (err) {
      console.error('[GeogroupService][getLeaderboardBySubGroups]', err);
      throw err;
    }
  }
  static async sendEmailToParticipants(challengeId, email, usersIds, body) {
    try {
      const params = {
        users_ids: usersIds,
        contact_email: email
      };
      if (body) params.email_body = body;
      await _http.HttpService.post('v2', `/challenges/${challengeId}/send-contact-email`, [], [], JSON.stringify(params));
    } catch (err) {
      console.error('[GeogroupService][sendEmailToParticipants]', err);
      throw err;
    }
  }
  static async getNewsPosts(geoGroupId, {
    ordering,
    page,
    pageSize
  }) {
    try {
      const {
        count,
        next,
        results
      } = await _http.HttpService.get('v5', `/geogroups/${geoGroupId}/news`, [{
        key: 'ordering',
        value: ordering
      }, {
        key: 'page',
        value: page
      }, {
        key: 'page_size',
        value: pageSize
      }]);
      return {
        count,
        hasNext: Boolean(next),
        results: results.map(parseNewsPost)
      };
    } catch (err) {
      console.error('[GeogroupService][getNewsPosts]', err);
      throw err;
    }
  }
  static async getNewsPost({
    partner,
    geoGroupId,
    newsPostId
  }) {
    try {
      const data = await _http.HttpService.get('v5', `/geogroups/${geoGroupId}/news/${newsPostId}`, [], [], null, {
        partner: partner.code
      });
      return parseNewsPost(data);
    } catch (err) {
      console.error('[GeogroupService][getNewsPost]', err);
      throw err;
    }
  }
  static async addNewsPost(geoGroupId, {
    author_type,
    text,
    photo,
    geo_group
  }, partner) {
    try {
      const props = {
        author_type,
        text: formatNewsPostContent(text),
        photo,
        geo_group
      };
      const formData = new FormData();
      Object.keys(props).forEach(key => {
        const value = props[key];
        if (value !== undefined) {
          if (typeof value === 'number') formData.append(key, `${value}`);else formData.append(key, value);
        }
      });
      const data = await _http.HttpService.post('v5', `/geogroups/${geoGroupId}/news`, [], [], formData, partner ? {
        partner: partner.code
      } : undefined);
      return parseNewsPost(data);
    } catch (err) {
      console.error('[GeogroupService][addNewsPost]', err);
      throw err;
    }
  }
  static async updateNewsPost(geoGroupId, id, {
    author_type,
    text,
    photo
  }, partner) {
    try {
      const props = {
        author_type,
        text: formatNewsPostContent(text),
        photo
      };
      let body;
      if (props.photo) {
        const formData = new FormData();
        Object.keys(props).forEach(key => {
          const value = props[key];
          if (value) formData.append(key, value);
        });
        body = formData;
      } else {
        body = JSON.stringify(props);
      }
      const data = await _http.HttpService.patch('v5', `/geogroups/${geoGroupId}/news/${id}`, [], [], body, partner ? {
        partner: partner.code
      } : undefined);
      return parseNewsPost(data);
    } catch (err) {
      console.error('[GeogroupService][updateNewsPost]', err);
      throw err;
    }
  }
  static async removeNewsPost(geoGroupId, {
    id
  }, partner) {
    try {
      await _http.HttpService.delete('v5', `/geogroups/${geoGroupId}/news/${id}`, [], [], null, partner ? {
        partner: partner.code
      } : undefined);
      return true;
    } catch (err) {
      console.error('[GeogroupService][removeNewsPost]', err);
      throw err;
    }
  }
  static async getStats({
    geoGroupId,
    period
  }) {
    try {
      const data = await _http.HttpService.get('v2', `/geogroups/${geoGroupId}/stats`, [...(0, _models.periodToParams)(period)]);
      const stats = period.unit === 'all_period' ? new _models.GeogroupStats(data[0]?.count_manually_joined_members || 0, []) : parseGeogroupStats(data);
      return stats;
    } catch (err) {
      console.error('[GeogroupService][getStats]', err);
      throw err;
    }
  }
  static async getActivityStats({
    geoGroupId,
    area
  }, period) {
    if (geoGroupId === null) throw new Error('partner has no geogroup identifier');
    try {
      const [data, computedRouteStats] = await Promise.all([_http.HttpService.get('v2', `/geogroups/${geoGroupId}/activities`, [...(0, _models.periodToParams)(period)]), area ? _stats2.StatsService.getComputedRouteStats(period) : null]);
      if (period.unit === 'all_period') {
        const {
          counter_distance: totalDistance,
          counter_home_work_reference_trips_distance: totalHomeWorkDistance,
          counter_duration: totalDuration,
          counter_home_work_reference_trips_duration: totalHomeWorkDuration,
          counter_traces: totalNbRoutes,
          counter_home_work_reference_trips_traces: totalHomeWorkJourneys,
          counter_active_user: nbActiveUsers,
          counter_active_user_with_home_work_trace: nbActiveUsersWithHomeWorkTrace,
          counter_home_work_reference_trips_co2_saved: totalHomeWorkSavedCO2InKg
        } = data[0];
        return new _models.ActivityStats(computedRouteStats?.count || 0, totalDistance, totalDuration, totalNbRoutes, [], totalHomeWorkDistance, totalHomeWorkDuration, totalHomeWorkJourneys, totalHomeWorkSavedCO2InKg, nbActiveUsers, nbActiveUsersWithHomeWorkTrace);
      }
      data.sort((a, b) => a.activity_day.localeCompare(b.activity_day));
      const stats = parseActivityStats(data, computedRouteStats);
      return stats;
    } catch (err) {
      console.error('[GeogroupService][getActivityStats]', err);
      throw err;
    }
  }
  static async getSubgroupsStats({
    geoGroupId,
    subgroupType,
    period,
    limit,
    ordering
  }) {
    try {
      const params = [{
        key: 'sub_group_type',
        value: backendSubGroupTypesMap[subgroupType]
      }, {
        key: 'ordering',
        value: ordering
      }, ...(0, _models.periodToParams)(period)];
      if (limit) params.push({
        key: 'limit',
        value: limit
      });
      const data = await _http.HttpService.get('v2', `/geogroups/${geoGroupId}/sub_group_aggregated_stats`, params);
      return data.map(parseGeogroupSubgroupsStats);
    } catch (err) {
      console.error('[GeogroupService][getSubgroupsStats]', err);
      throw err;
    }
  }
  static async getAverageJourneyStats({
    geoGroupId,
    period,
    journeysType
  }) {
    try {
      const data = await _http.HttpService.get('v2', `/geogroups/${geoGroupId}/average_trace_stats`, [{
        key: 'only_home_work_traces',
        value: journeysType === 'homeWork'
      }, ...(0, _models.periodToParams)(period)]);
      return parseAverageJourneyStats(data);
    } catch (err) {
      console.error('[GeogroupService][getAverageJourneyStats]', err);
      throw err;
    }
  }
  static async getStatements({
    event,
    groupId
  }) {
    const {
      startDate,
      endDate
    } = event;
    const strStartDate = startDate.toISOString().split('T')[0].split('-').reverse().join('-');
    const strEndDate = endDate.toISOString().split('T')[0].split('-').reverse().join('-');
    try {
      const {
        results
      } = await _http.HttpService.get('v2', `/geogroups/${groupId}/manual_activities`, [{
        key: 'period',
        value: 'custom'
      }, {
        key: 'date_start',
        value: strStartDate
      }, {
        key: 'date_end',
        value: strEndDate
      }]);
      const statements = results.map(parseGeogroupStatement);
      return statements;
    } catch (err) {
      console.error('[GeogroupService][getStatements]', err);
      throw err;
    }
  }
  static async addStatement({
    groupId,
    strDate: activity_day,
    distance: counter_distance,
    nbTraces: counter_traces
  }) {
    try {
      const data = await _http.HttpService.post('v2', `/geogroups/${groupId}/manual_activities`, [], [], JSON.stringify({
        activity_day,
        counter_distance,
        counter_traces
      }));
      const statement = parseGeogroupStatement(data);
      return statement;
    } catch (err) {
      console.error('[GeogroupService][addStatement]', err);
      throw err;
    }
  }
  static async updateStatement(id, {
    groupId,
    strDate: activity_day,
    distance: counter_distance,
    nbTraces: counter_traces
  }) {
    try {
      const data = await _http.HttpService.patch('v2', `/geogroups/${groupId}/manual_activities/${id}`, [], [], JSON.stringify({
        activity_day,
        counter_distance,
        counter_traces
      }));
      const statement = parseGeogroupStatement(data);
      return statement;
    } catch (err) {
      console.error('[GeogroupService][updateStatement]', err);
      throw err;
    }
  }
  static async likeNewsPost({
    newsPostId
  }) {
    try {
      await _http.HttpService.put('v2', `/geo_group_news/${newsPostId}/like`);
      return true;
    } catch (err) {
      console.error('[GeogroupService][likeNewsPost]', err);
      throw err;
    }
  }
  static async unlikeNewsPost({
    newsPostId
  }) {
    try {
      await _http.HttpService.delete('v2', `/geo_group_news/${newsPostId}/like`);
      return true;
    } catch (err) {
      console.error('[GeogroupService][unlikeNewsPost]', err);
      throw err;
    }
  }
  static async getSubgroupTypes({
    groupId
  }) {
    try {
      const data = await _http.HttpService.get('v1', `/geogroups/${groupId}/sub_group_types`);
      return data.map(key => subGroupTypesMap[key]).filter(Boolean);
    } catch (err) {
      console.error('[GeogroupService][getSubgroupTypes]', err);
      throw err;
    }
  }
  static async askToJoinEvent({
    geoGroupId,
    eventId
  }) {
    try {
      await _http.HttpService.post('v2', `/geogroups/${geoGroupId}/request_to_participate_event`, [], [], JSON.stringify({
        event_id: eventId
      }));
      return true;
    } catch (err) {
      console.error('[GeogroupService][askToJoinEvent]', err);
      throw err;
    }
  }
}
exports.GeogroupService = GeogroupService;
const backendSubGroupTypesMap = {
  companyTeam: 'COMPANY_DEPARTMENT',
  companySite: 'COMPANY_SITE',
  companySubsidiary: 'COMPANY_SUBSIDIARY',
  companyRegion: 'COMPANY_REGION'
};
const subGroupTypesMap = exports.subGroupTypesMap = {
  COMPANY_DEPARTMENT: 'companyTeam',
  COMPANY_SITE: 'companySite',
  COMPANY_SUBSIDIARY: 'companySubsidiary',
  COMPANY_REGION: 'companyRegion'
};
const automaticChallengeStatusMap = {
  AUTOMATIC_DISTANCE: 'automaticDistance',
  DISABLED: 'disabled',
  EDITORIALIZED: 'editorialized'
};
const backendAutomaticChallengeStatusMap = {
  automaticDistance: 'AUTOMATIC_DISTANCE',
  disabled: 'DISABLED',
  editorialized: 'EDITORIALIZED'
};
function parseGeogroup({
  id,
  type,
  area,
  title,
  code,
  photo,
  geo_point,
  total_members,
  total_distance,
  automatic_challenge_creation,
  size_range,
  address,
  parent,
  sub_group_type,
  partner,
  publication_status,
  banner_picture,
  description,
  link_label,
  link_url,
  open_membership
}, backendUrl) {
  return new _models.Geogroup(id, backendTypesMap[type], area, title || '', code, photo ? `${backendUrl}${photo}` : null, geo_point ? new _models.Place(id, geo_point, address ? sub_group_type === 'COMPANY_SITE' ? {
    primaryText: title || '',
    secondaryText: address
  } : {
    primaryText: address
  } : undefined) : null, total_members, total_distance, automatic_challenge_creation ? automaticChallengeStatusMap[automatic_challenge_creation] : 'disabled', code === 'lyon', size_range, parent, sub_group_type ? subGroupTypesMap[sub_group_type] : sub_group_type, partner ? (0, _partner.parsePartner)({
    partner
  }) : partner, publication_status ? _publicationStatus.publicationStatuses[publication_status] : undefined, banner_picture ? `${backendUrl}${banner_picture}` : undefined, description, link_url ? {
    url: link_url,
    label: link_label || null
  } : null, Boolean(open_membership));
}
const userGeogroupStatuses = {
  AUTOMATICALLY_JOIN: 'automaticallyJoin',
  AUTOMATICALLY_QUIT: 'automaticallyQuit',
  MANUALLY_JOIN: 'manuallyJoin',
  MANUALLY_QUIT: 'manuallyQuit',
  WAITING_FOR_APPROVAL: 'waitingForApproval'
};
const backendUserGeogroupStatuses = {
  automaticallyJoin: 'AUTOMATICALLY_JOIN',
  automaticallyQuit: 'AUTOMATICALLY_QUIT',
  manuallyJoin: 'MANUALLY_JOIN',
  manuallyQuit: 'MANUALLY_QUIT',
  waitingForApproval: 'WAITING_FOR_APPROVAL'
};
function parseUserGeogroup({
  type,
  group,
  join_date,
  last_activity_date,
  automatic_challenge_creation,
  user_type
}, backendUrl) {
  return new _models.UserGeogroup(userGeogroupStatuses[type], parseGeogroup(group, backendUrl), (0, _moment.default)(join_date), (0, _moment.default)(last_activity_date), automatic_challenge_creation ? automaticChallengeStatusMap[automatic_challenge_creation] : 'disabled', user_type === 'ADMIN');
}
function parseGeogroupMember({
  id,
  username,
  join_date,
  last_activity_date,
  meters
}) {
  if (!id) return null;
  return new _models.GeogroupMember(id, username, (0, _moment.default)(join_date), (0, _moment.default)(last_activity_date), meters || 0);
}
const challengeTypes = {
  TRAVELED_DISTANCE: 'traveledDistance',
  CYCLING_DAYS: 'cyclingDays',
  NO_TARGET: 'noTarget',
  BTTF_POINTS: 'bttf'
};
const backendChallengeTypes = exports.backendChallengeTypes = {
  traveledDistance: 'TRAVELED_DISTANCE',
  cyclingDays: 'CYCLING_DAYS',
  homeWorkJourneysCount: 'TRACES_COUNT',
  journeysCount: 'TRACES_COUNT',
  noTarget: 'NO_TARGET',
  bttf: 'BTTF_POINTS'
};
const collaborationTypes = {
  INDIVIDUAL: 'individual',
  EVERYONE: 'global'
};
const traceTypes = {
  ALL: 'all',
  COMMUTING: 'commuting',
  NOT_APPLICABLE: 'notApplicable'
};
function parseChallenge({
  id,
  target_type,
  collaboration_type,
  trace_type,
  start_datetime,
  end_datetime,
  title,
  description,
  photo,
  details_url,
  total_members,
  progress_value,
  target_value,
  publication_status,
  event,
  default_sub_group_display,
  group,
  certified
}, backendUrl, sites) {
  if (publication_status !== 'PUBLISHED') return null;
  let type = challengeTypes[target_type];
  if (target_type === 'TRACES_COUNT') {
    if (trace_type === 'COMMUTING') type = 'homeWorkJourneysCount';else if (trace_type === 'ALL') type = 'journeysCount';
  }
  if (!type) return null;
  return new _models.Challenge(id, type, default_sub_group_display && ['COMPANY_DEPARTMENT', 'COMPANY_SITE'].includes(default_sub_group_display) ? 'teams' : collaborationTypes[collaboration_type], traceTypes[trace_type], (0, _moment.default)(start_datetime), (0, _moment.default)(end_datetime), title || `Challenge #${id}`, description, photo ? `${backendUrl}${photo}` : null, details_url, total_members, progress_value, target_value || 0, _publicationStatus.publicationStatuses[publication_status], typeof event === 'object' ? event?.id || null : event, default_sub_group_display && subGroupTypesMap[default_sub_group_display] || null, group, Boolean(sites?.find(({
    id
  }) => id === group)), typeof event === 'object' && event?.sponsor || null, certified);
}
function parseChallengeTemplate(eventId, {
  id,
  target_type,
  collaboration_type,
  trace_type,
  start_datetime,
  end_datetime,
  title,
  description,
  photo,
  icon,
  details_url,
  target_value,
  default_sub_group_display
}, backendUrl) {
  let type = challengeTypes[target_type];
  if (target_type === 'TRACES_COUNT') {
    if (trace_type === 'COMMUTING') type = 'homeWorkJourneysCount';else if (trace_type === 'ALL') type = 'journeysCount';
  }
  if (!type) return null;
  return new _models.ChallengeTemplate(id, type, default_sub_group_display && ['COMPANY_DEPARTMENT', 'COMPANY_SITE'].includes(default_sub_group_display) ? 'teams' : collaborationTypes[collaboration_type], traceTypes[trace_type], (0, _moment.default)(start_datetime), (0, _moment.default)(end_datetime), title || `Challenge #${id}`, description, photo ? photo.indexOf('https') === -1 && photo.indexOf('http') === -1 ? `${backendUrl}${photo}` : photo : null, icon ? icon.indexOf('https') === -1 && icon.indexOf('http') === -1 ? `${backendUrl}${icon}` : icon : null, details_url, target_value || 0, eventId, default_sub_group_display && subGroupTypesMap[default_sub_group_display] || null);
}
function parseNewsPost({
  id,
  geo_group,
  creator,
  author_type,
  created,
  text,
  photo,
  link_label,
  link_url,
  publication_date,
  type,
  likes_count,
  liked
}) {
  const typesMap = {
    CHALLENGE_END: 'challengeEnd',
    CHALLENGE_OBJECTIVE_100: 'challengeObjective100',
    CHALLENGE_OBJECTIVE_25: 'challengeObjective25',
    CHALLENGE_OBJECTIVE_50: 'challengeObjective50',
    CHALLENGE_OBJECTIVE_75: 'challengeObjective75',
    CHALLENGE_START: 'challengeStart',
    CHALLENGE_TOP_RANKING: 'challengeTopRanking',
    MANUAL: 'manual'
  };
  return new _models.GeogroupNewsPost(id, geo_group ? {
    id: geo_group.id,
    photo: geo_group.photo ? `${_environment.defaultEnvironment.backendUrl}${geo_group.photo}` : geo_group.photo,
    title: geo_group.title
  } : null, creator ? {
    id: creator.id,
    profilePicture: creator.profile_picture ? `${_environment.defaultEnvironment.backendUrl}${creator.profile_picture}` : creator.profile_picture,
    username: creator.username
  } : null, author_type === 'AUTHOR_AS_GROUP', (0, _moment.default)(created), text, photo ? photo.url : null, link_url ? {
    url: link_url,
    label: link_label
  } : null, publication_date ? (0, _moment.default)(publication_date) : null, type && typesMap[type], likes_count, liked);
}
function parseGeogroupStats(data) {
  let maxMembers = 0;
  const stats = {};
  data.forEach(({
    unit: strDate,
    count_manually_joined_members: nbMembers
  }) => {
    const date = (0, _stats.parseStatsDate)({
      strDate
    });
    if (date) {
      const strDate = date.format('l');
      stats[strDate] = {
        strDate,
        date,
        nbMembers
      };
      maxMembers = Math.max(maxMembers, nbMembers);
    }
  });
  return new _models.GeogroupStats(maxMembers, Object.values(stats));
}
function parseActivityStats(data, computedRouteStats) {
  let totalDistance = 0;
  let totalHomeWorkDistance = 0;
  let totalDuration = 0;
  let totalHomeWorkDuration = 0;
  let totalNbRoutes = 0;
  let totalHomeWorkJourneys = 0;
  let maxActiveUsers = 0;
  let maxActiveUsersWithHomeWorkTrace = 0;
  let totalHomeWorkSavedCO2InKg = 0;
  const stats = {};
  data.forEach(({
    activity_day: strDate,
    counter_distance: distance,
    counter_home_work_reference_trips_distance: homeWorkDistance,
    counter_duration: duration,
    counter_home_work_reference_trips_duration: homeWorkDuration,
    counter_traces: nbRoutes,
    counter_home_work_reference_trips_traces: homeWorkJourneys,
    counter_active_user: nbActiveUsers,
    counter_active_user_with_home_work_trace: nbActiveUsersWithHomeWorkTrace,
    counter_home_work_reference_trips_co2_saved: homeWorkSavedCO2InKg
  }) => {
    const date = (0, _stats.parseStatsDate)({
      strDate
    });
    if (date) {
      const strDate = date.format('l');
      stats[strDate] = {
        strDate,
        date,
        nbComputedRoutes: 0,
        distance,
        homeWorkDistance,
        duration,
        homeWorkDuration,
        nbRoutes,
        homeWorkJourneys,
        nbActiveUsers,
        nbActiveUsersWithHomeWorkTrace,
        homeWorkSavedCO2InKg
      };
    }
    totalDistance += distance;
    totalHomeWorkDistance = totalHomeWorkDistance + (homeWorkDistance || 0);
    totalDuration += duration;
    totalHomeWorkDuration = totalHomeWorkDuration + (homeWorkDuration || 0);
    totalNbRoutes += nbRoutes;
    totalHomeWorkJourneys = totalHomeWorkJourneys + (homeWorkJourneys || 0);
    maxActiveUsers = Math.max(maxActiveUsers, nbActiveUsers || 0);
    maxActiveUsersWithHomeWorkTrace = Math.max(maxActiveUsersWithHomeWorkTrace, nbActiveUsersWithHomeWorkTrace || 0);
    totalHomeWorkSavedCO2InKg += homeWorkSavedCO2InKg || 0;
  });
  computedRouteStats?.data.forEach(({
    date,
    count
  }) => {
    const strDate = date.format('l');
    if (stats[strDate]) stats[strDate].nbComputedRoutes = count;else stats[strDate] = {
      strDate,
      date,
      nbComputedRoutes: count,
      distance: 0,
      homeWorkDistance: 0,
      duration: 0,
      homeWorkDuration: 0,
      nbRoutes: 0,
      homeWorkJourneys: 0,
      nbActiveUsers: 0,
      nbActiveUsersWithHomeWorkTrace: 0,
      homeWorkSavedCO2InKg: 0
    };
  });
  return new _models.ActivityStats(computedRouteStats?.count || 0, totalDistance, totalDuration, totalNbRoutes, Object.values(stats), totalHomeWorkDistance, totalHomeWorkDuration, totalHomeWorkJourneys, totalHomeWorkSavedCO2InKg, maxActiveUsers, maxActiveUsersWithHomeWorkTrace);
}
function parseGeogroupSubgroupsStats({
  group_id: subgroupId,
  group_title: subgroupTitle,
  stats_counter_duration: duration,
  stats_counter_distance: distance,
  stats_counter_traces: journeys,
  stats_counter_home_work_reference_trips_duration: homeWorkDuration,
  stats_counter_home_work_reference_trips_distance: homeWorkDistance,
  stats_counter_home_work_reference_trips_traces: homeWorkJourneys,
  counter_active_user: activeMembers,
  counter_active_user_with_home_work_trace: activeMembersWithHomeWorkJourney
}) {
  return {
    subgroupId,
    subgroupTitle,
    duration,
    distance,
    journeys,
    homeWorkDuration,
    homeWorkDistance,
    homeWorkJourneys,
    activeMembers,
    activeMembersWithHomeWorkJourney
  };
}
function parseAverageJourneyStats({
  average_duration_in_seconds: averageDuration,
  average_distance_in_meters: averageDistance,
  duration_stats,
  distance_stats
}) {
  return {
    averageDuration,
    averageDistance,
    durationStats: duration_stats.map(({
      greater_than: min,
      less_than_or_equal: max,
      trace_count: count
    }) => ({
      min,
      max,
      count
    })),
    distanceStats: distance_stats.map(({
      greater_than: min,
      less_than_or_equal: max,
      trace_count: count
    }) => ({
      min,
      max,
      count
    }))
  };
}
function parseGeogroupStatement({
  id,
  activity_day,
  counter_distance,
  counter_traces
}) {
  return new _models.GeogroupStatement(id, activity_day, Math.round((counter_distance || 0) / 100) / 10, counter_traces || 0);
}
function formatNewsPostContent(content) {
  function decodeHtmlEntity(str) {
    return str.replace(/&#(\d+);/g, function (match, dec) {
      return String.fromCharCode(dec);
    });
  }
  return decodeHtmlEntity(content).replaceAll('<strong>', '<b>').replaceAll('</strong>', '</b>').replaceAll('<p></p>', '<br/>').replaceAll('&nbsp;', ' ');
}